import { render, staticRenderFns } from "./VerifierBoxUI.vue?vue&type=template&id=1137e11e&scoped=true&"
import script from "./VerifierBoxUI.vue?vue&type=script&lang=js&"
export * from "./VerifierBoxUI.vue?vue&type=script&lang=js&"
import style0 from "./VerifierBoxUI.vue?vue&type=style&index=0&id=1137e11e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137e11e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
